import script from "./SearchSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchSection.vue?vue&type=script&setup=true&lang=ts"

import "./SearchSection.vue?vue&type=style&index=0&id=4451a2ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4451a2ae"]])

export default __exports__